export default __webpack_public_path__ + "assets/97685ca08d3fd8fc58f63b801ee8f972.png";